import { render, staticRenderFns } from "./project-header.vue?vue&type=template&id=f0a2c344&scoped=true&"
import script from "./project-header.vue?vue&type=script&lang=js&"
export * from "./project-header.vue?vue&type=script&lang=js&"
import style0 from "./project-header.vue?vue&type=style&index=0&id=f0a2c344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2c344",
  null
  
)

component.options.__file = "project-header.vue"
export default component.exports